module.exports = __webpack_public_path__ + "static/img/ptld_8.03e92569.png";